import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card p-6 sm:p-8 mb-4"
}
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "title-main" }, "การชำระเงิน", -1)
const _hoisted_5 = { class: "flex flex-col space-y-6 p-3 sm:p-6" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "col-span-full" }
const _hoisted_8 = {
  key: 0,
  class: "col-span-1 border-2 rounded-md border-gray-100 p-2"
}
const _hoisted_9 = { class: "flex space-x-4 items-center" }
const _hoisted_10 = ["src", "onerror"]
const _hoisted_11 = { class: "w-full flex flex-col text-left gap-1" }
const _hoisted_12 = { class: "text-sm clamp-1 text-gray-500" }
const _hoisted_13 = { class: "text-sm clamp-1 text-gray-500" }
const _hoisted_14 = { class: "text-sm clamp-1 text-gray-500" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-6 h-6",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    id: "Group_733",
    "data-name": "Group 733",
    transform: "translate(22141 4199)"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      id: "Rectangle_2086",
      "data-name": "Rectangle 2086",
      width: "24",
      height: "24",
      transform: "translate(-22141 -4199)",
      fill: "#fff",
      opacity: "0"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      id: "Icon_awesome-copy",
      "data-name": "Icon awesome-copy",
      d: "M11.438,16.014v1.43a.858.858,0,0,1-.858.858H.858A.858.858,0,0,1,0,17.443V4.289a.858.858,0,0,1,.858-.858H3.432v10.58a2,2,0,0,0,2,2Zm0-12.3V0H5.433a.858.858,0,0,0-.858.858V14.012a.858.858,0,0,0,.858.858h9.723a.858.858,0,0,0,.858-.858V4.575H12.3A.86.86,0,0,1,11.438,3.717Zm4.324-1.109L13.405.251A.858.858,0,0,0,12.8,0h-.217V3.432h3.432V3.215a.858.858,0,0,0-.251-.607Z",
      transform: "translate(-22137.008 -4196.15)",
      fill: "#bababa"
    })
  ])
], -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 0,
  class: "col-span-full items-center rounded-full py-2 px-4 w-max flex flex-row gap-2 mt-2",
  style: {"background-color":"#e9f9e7"}
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", {
  style: {"color":"#1ebd0b"},
  class: "text-sm leading-4"
}, " ตรวจสอบแล้ว ", -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = {
  key: 1,
  class: "col-span-full items-center rounded-full py-2 px-4 w-max flex flex-row gap-2 mt-2",
  style: {"background-color":"#f9f1e7"}
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", {
  style: {"color":"#bd750f"},
  class: "text-sm leading-4"
}, " รอการตรวจสอบ ", -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = {
  key: 2,
  class: "col-span-full items-center rounded-full py-2 px-4 w-max flex flex-row gap-2 bg-red-50 mt-2"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm leading-4 text-red-500" }, "ตรวจสอบไม่ผ่าน", -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = {
  key: 1,
  class: "col-span-1 lg:col-span-2 row-span-3"
}
const _hoisted_28 = ["src"]
const _hoisted_29 = {
  key: 2,
  class: "col-span-1"
}
const _hoisted_30 = { class: "flex flex-col md:flex-row gap-4" }
const _hoisted_31 = { class: "flex gap-2" }
const _hoisted_32 = { class: "text-xs md:text-sm text-gray-500 opacity-70" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", null, "ผู้ขายตรวจการชำระ", -1)
const _hoisted_34 = { class: "hidden xl:block" }
const _hoisted_35 = { class: "mb-2" }
const _hoisted_36 = { class: "grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4" }
const _hoisted_37 = { class: "flex space-x-4 items-center h-full relative" }
const _hoisted_38 = ["src", "onerror"]
const _hoisted_39 = { class: "flex-1 w-20 flex flex-col text-left gap-1" }
const _hoisted_40 = {
  key: 0,
  class: "text-sm md:text-base clamp-1 text-gray-500"
}
const _hoisted_41 = {
  key: 0,
  class: "flex justify-between"
}
const _hoisted_42 = { class: "text-sm md:text-base clamp-1 text-gray-500" }
const _hoisted_43 = {
  key: 1,
  class: "flex justify-between"
}
const _hoisted_44 = { class: "text-sm md:text-base clamp-1 text-gray-500" }
const _hoisted_45 = { class: "flex flex-col text-left gap-1" }
const _hoisted_46 = { class: "text-xs md:text-sm text-gray-500 opacity-70 clamp-1" }
const _hoisted_47 = {
  key: 0,
  class: "text-sm md:text-md text-gray-500 font-semibold"
}
const _hoisted_48 = {
  key: 1,
  class: "text-sm md:text-md text-gray-500 font-semibold"
}
const _hoisted_49 = ["onClick"]
const _hoisted_50 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-6 h-6",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    id: "Group_733",
    "data-name": "Group 733",
    transform: "translate(22141 4199)"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      id: "Rectangle_2086",
      "data-name": "Rectangle 2086",
      width: "24",
      height: "24",
      transform: "translate(-22141 -4199)",
      fill: "#fff",
      opacity: "0"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      id: "Icon_awesome-copy",
      "data-name": "Icon awesome-copy",
      d: "M11.438,16.014v1.43a.858.858,0,0,1-.858.858H.858A.858.858,0,0,1,0,17.443V4.289a.858.858,0,0,1,.858-.858H3.432v10.58a2,2,0,0,0,2,2Zm0-12.3V0H5.433a.858.858,0,0,0-.858.858V14.012a.858.858,0,0,0,.858.858h9.723a.858.858,0,0,0,.858-.858V4.575H12.3A.86.86,0,0,1,11.438,3.717Zm4.324-1.109L13.405.251A.858.858,0,0,0,12.8,0h-.217V3.432h3.432V3.215a.858.858,0,0,0-.251-.607Z",
      transform: "translate(-22137.008 -4196.15)",
      fill: "#bababa"
    })
  ])
], -1)
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = { class: "block xl:hidden" }
const _hoisted_53 = { class: "flex flex-col gap-4 fixed top-5 right-5 w-3/5 lg:w-2/5 xl:w-1/5" }
const _hoisted_54 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center justify-center w-12 bg-green-500\"><svg class=\"w-6 h-6 text-white fill-current\" viewBox=\"0 0 40 40\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20 3.33331C10.8 3.33331 3.33337 10.8 3.33337 20C3.33337 29.2 10.8 36.6666 20 36.6666C29.2 36.6666 36.6667 29.2 36.6667 20C36.6667 10.8 29.2 3.33331 20 3.33331ZM16.6667 28.3333L8.33337 20L10.6834 17.65L16.6667 23.6166L29.3167 10.9666L31.6667 13.3333L16.6667 28.3333Z\"></path></svg></div><div class=\"px-4 py-2 -mx-3\"><div class=\"mx-3\"><span class=\"font-semibold text-green-500 dark:text-green-400\">Success</span><p class=\"text-sm text-gray-600 dark:text-gray-200\">Coppy Success</p></div></div>", 2)
const _hoisted_56 = [
  _hoisted_54
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_paymentConfirmComp = _resolveComponent("paymentConfirmComp")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (
      (_ctx.data && !_ctx.data.shippingConfirmedData) ||
      (_ctx.data.shippingConfirmedData && !_ctx.data.shippingConfirmedData.isCOD)
    )
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("img", {
              class: "bullet_main",
              src: require('@/assets/icon_bullet/payment.svg'),
              alt: ""
            }, null, 8, _hoisted_3),
            _hoisted_4
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.paymentRows.length)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, "ประเภทการชำระเงิน"))
              : _createCommentVNode("", true),
            (_ctx.paymentRows.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.paymentRows, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4",
                    key: item.paymentRowId
                  }, [
                    _createElementVNode("p", _hoisted_7, "ครั้งที่ " + _toDisplayString(_ctx.paymentRows.length - index), 1),
                    (item.paymentConfirmedData)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("img", {
                              class: "min-w-10 max-w-10 min-h-10 max-h-10 md:min-w-16 md:max-w-16 md:min-h-16 md:max-h-16 rounded-md bg-contain object-contain bg-center bg-no-repeat bg-white border border-gray-100",
                              src: 
                    _ctx.envMedia +
                    '/public/' +
                    (item.paymentConfirmedData.paymentMethodType !== 'cash'
                      ? item.paymentConfirmedData.paymentIconUrl
                      : 'icons/payment/cash.webp')
                  ,
                              onerror: `this.src = '${_ctx.envMedia}/public/icons/web/empty.png'`,
                              alt: ""
                            }, null, 8, _hoisted_10),
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("p", _hoisted_12, _toDisplayString(item.paymentConfirmedData.paymentMethodType !== "cash"
                        ? item.paymentConfirmedData.paymentMethodAttribute
                            .accountName
                        : item.paymentConfirmedData.paymentAliasName), 1),
                              _createElementVNode("p", _hoisted_13, " จำนวนเงิน " + _toDisplayString(_ctx.func_service.currency(
                        item.paymentAttachmentData?.paymentPrice
                      )) + " บาท ", 1),
                              _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.convertDate(item.paymentAttachmentData?.paymentDate)) + " " + _toDisplayString(item.paymentAttachmentData?.paymentTime) + " น. ", 1)
                            ]),
                            (item.paymentConfirmedData.paymentMethodType !== 'cash')
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  onClick: ($event: any) => (_ctx.copyLink(item.paymentConfirmedData)),
                                  class: "inline-flex w-10 justify-center bg-gray-100 p-2 shadow-md rounded-full cursor-pointer right-0"
                                }, _hoisted_17, 8, _hoisted_15))
                              : _createCommentVNode("", true)
                          ]),
                          (item.paymentConfirmedData.paymentMethodType !== 'cash')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (item.paymentRowStatus === 'COMPLETE')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
                                  : _createCommentVNode("", true),
                                (item.paymentRowStatus === 'WAIT')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))
                                  : _createCommentVNode("", true),
                                (item.paymentRowStatus === 'REJECT')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_26))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (item.paymentConfirmedData)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          (item.paymentConfirmedData.paymentMethodType !== 'cash')
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                class: "object-contain w-full bg-gray-100 m-auto",
                                style: {"width":"298px","height":"515px"},
                                src: _ctx.imgUrl(item.paymentAttachmentData.paymentImageUrl),
                                alt: ""
                              }, null, 8, _hoisted_28))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (
              item.paymentAttachmentData &&
              item.paymentConfirmedData.paymentMethodType !== 'cash'
            )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("div", _hoisted_32, [
                                (item.paymentRowStatus !== 'WAIT')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _hoisted_33,
                                      _createElementVNode("p", null, _toDisplayString(_ctx.convertDateAndTime(item.updatedAt)), 1)
                                    ], 64))
                                  : _createCommentVNode("", true),
                                _createElementVNode("p", null, " แจ้งโอนโดย " + _toDisplayString(item.createdBy
                        ? "ผู้ขาย"
                        : _ctx.data.customerContactInfo?.fullName), 1),
                                _createElementVNode("p", null, _toDisplayString(_ctx.convertDateAndTime(item.createdAt)), 1)
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.mapListPaymentAvailableData(
            _ctx.data.paymentAvailableData
          ), (itemPayment) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: itemPayment.name
                  }, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("p", _hoisted_35, _toDisplayString(itemPayment.name === "bankDeposit" ? "ธนาคาร" : "เงินสด"), 1)
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemPayment.data, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.paymentMethodId,
                          class: _normalizeClass(["border-2 rounded-md border-gray-100 p-2", 
                (_ctx.data.statusOrderOnBuyer ==
                  _ctx.StatusOrderCustomer.B2_AwaitingPayment ||
                  _ctx.data.statusOrderOnBuyer == _ctx.StatusOrderCustomer.B3_Paid) &&
                _ctx.data.statusOrderOnSeller !==
                  _ctx.StatusOrderSeller.S4_AwaitingFulfillment
                  ? 'hidden xl:block'
                  : ''
              ])
                        }, [
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("img", {
                              class: "min-w-10 max-w-10 min-h-10 max-h-10 md:min-w-16 md:max-w-16 md:min-h-16 md:max-h-16 rounded-md bg-contain object-contain bg-center bg-no-repeat bg-white border border-gray-100",
                              src: 
                    _ctx.envMedia +
                    '/public/' +
                    (item.paymentMethodType !== 'cash'
                      ? item.paymentIconUrl
                      : 'icons/payment/cash.webp')
                  ,
                              onerror: `this.src =
                    '${_ctx.envMedia}/public/icons/web/empty.png'`,
                              alt: ""
                            }, null, 8, _hoisted_38),
                            _createElementVNode("div", _hoisted_39, [
                              (item.paymentMethodType === 'cash')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(item.paymentAliasName), 1))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    (item.paymentMethodType === 'bankDeposit')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                          _createElementVNode("p", _hoisted_42, _toDisplayString(_ctx.getAttribute(item).bankAccountName
                            ? _ctx.convertBankName(
                                _ctx.getAttribute(item).bankAccountName
                              )
                            : "") + " " + _toDisplayString(_ctx.getAttribute(item).branchName
                            ? "(" + _ctx.getAttribute(item).branchName + ")"
                            : ""), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (item.paymentMethodType === 'promptPay')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                          _createElementVNode("p", _hoisted_44, " พร้อมเพย์(" + _toDisplayString(item.note ? item.note : "") + ") ", 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_45, [
                                      _createElementVNode("p", _hoisted_46, _toDisplayString(_ctx.getAttribute(item).accountName), 1),
                                      (item.paymentMethodType === 'bankDeposit')
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_47, _toDisplayString(_ctx.paymentNumber(_ctx.getAttribute(item).accountNo)), 1))
                                        : _createCommentVNode("", true),
                                      (item.paymentMethodType === 'promptPay')
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_48, _toDisplayString(_ctx.promptPayNumber(
                            item.paymentMethodAttribute.accountNo,
                            item.paymentMethodAttribute.promptPayType
                          )), 1))
                                        : _createCommentVNode("", true)
                                    ])
                                  ], 64))
                            ]),
                            (item.paymentMethodType !== 'cash')
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  onClick: ($event: any) => (_ctx.copyLink(item)),
                                  class: "inline-flex w-10 justify-center bg-gray-100 p-2 shadow-md rounded-full cursor-pointer right-0"
                                }, _hoisted_51, 8, _hoisted_49))
                              : _createCommentVNode("", true)
                          ])
                        ], 2))
                      }), 128))
                    ])
                  ]))
                }), 128)),
            _createElementVNode("div", _hoisted_52, [
              _createVNode(_component_paymentConfirmComp, {
                ref: "paymentComp",
                data: _ctx.data
              }, null, 8, ["data"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_53, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dialogCopyArr, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item,
          class: "flex w-full max-w-sm overflow-hidden bg-white rounded-lg shadow-md z-20 dark:bg-gray-800"
        }, _hoisted_56))
      }), 128))
    ])
  ], 64))
}